import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';

import { Toast } from 'C4';

export default class MultipleChoice extends Component {
  constructor(props) {
    super(props);

    const { answersCorrect } = this.props;
    const answerStyles = answersCorrect.map(answer => (answer === 'true' ? 'correct' : ''));
    const activeStyles = answersCorrect.map(() => '');

    this.state = {
      selectedAnswers: [],
      answerStyles,
      activeStyles,
      toastContent: null,
    };

    this.changeAnswer = this.changeAnswer.bind(this);
  }

  resetForm() {
    const selected = [];
    const { children } = document.querySelector('.form__answers');
    Array.from(children).forEach((element, index) => {
      const input = document.getElementById(index);
      selected.push(input.checked.toString());
      this.setState({ selectedAnswers: selected });
    });
  }

  checkAnswers(answersCorrect, clickedAnswer) {
    const { selectedAnswers, activeStyles, answerStyles } = this.state;
    const { error, incorrectAnswerText, correctAnswerText } = this.props;
    const newStyles = activeStyles;

    if (selectedAnswers.length === 0) return i18n.translate('trainingScreens.choose');
    const allCorrect = selectedAnswers.every((answer, index) => answer.toString().toLowerCase() === answersCorrect[index].toString().toLowerCase());

    const i = clickedAnswer.parentNode.htmlFor;
    newStyles[i] = answerStyles[i];
    if (allCorrect) {
      this.props.contentComplete();
      this.setState({
        activeStyles: newStyles,
        toastContent: {
          type: 'success',
          position: 'bottom-center',
          content: correctAnswerText,
        },
      });
      return correctAnswerText;
    }
    this.resetForm();
    error(true);
    // this.setState({
    //   toastContent: {
    //     type: 'error',
    //     position: 'bottom-center',
    //     content: incorrectAnswerText,
    //   },
    // });
    return incorrectAnswerText;
  }

  checkImageAnswer(answersCorrect) {
    const { selectedAnswers, activeStyles } = this.state;
    const { error, incorrectAnswerText, correctAnswerText } = this.props;
    const newStyles = activeStyles;

    const allCorrect = selectedAnswers.every((answer, i) => answer === answersCorrect[i]);
    if (allCorrect) {
      this.props.contentComplete();
      this.setState({
        activeStyles: newStyles,
        toastContent: {
          position: 'bottom-center',
          content: correctAnswerText,
        },
      });
      return correctAnswerText;
    }

    error(true);
    // this.setState({
    //   toastContent: {
    //     type: 'error',
    //     position: 'bottom-center',
    //     content: incorrectAnswerText,
    //   },
    // });
    return incorrectAnswerText;
  }

  changeAnswer(target, layout, answersCorrect) {
    const selected = [];
    const form = document.querySelector('.form__answers');
    Array.from(form.children).forEach((element, index) => {
      const input = document.getElementById(index);
      selected.push(input.checked.toString());
    });
    this.setState({ selectedAnswers: selected }, () => {
      if (layout !== 'mMC') {
        this.checkAnswers(answersCorrect, target);
      }
    });
  }

  changeImageAnswer(e, answersCorrect) {
    const { length } = document.querySelector('.form__answers').children;
    const selectedAnswers = [];
    for (let i = 0; i < length; i += 1) {
      if (i.toString() === e.target.id) {
        selectedAnswers.push(true);
      } else selectedAnswers.push(false);
    }
    this.setState({ selectedAnswers }, () => {
      this.checkImageAnswer(answersCorrect);
    });
  }

  render() {
    const {
      question, answersCorrect, answer, layout, disableHeader, error, disableToast,
    } = this.props;

    const { answerStyles, activeStyles, toastContent } = this.state;

    return (
      <div className="container__question">
        {!disableHeader && <div className="container__question--image" />}
        <div className="container__question--content">
          <h4 className="container__title">{question}</h4>
          <Inputs
            answer={answer}
            change={(e) => {
              this.changeAnswer(e.target, layout, answersCorrect);
            }}
            changeImage={(e) => {
              this.changeImageAnswer(e, answersCorrect);
            }}
            layout={layout}
            answersCorrect={answersCorrect}
            answerStyles={answerStyles}
            activeStyles={activeStyles}
          />
          {!disableToast && (
            <Toast
              trigger={toastContent !== null}
              onOpen={() => { this.setState({ toastContent: null }); }}
              {...toastContent}
            />
          )}
          {layout === 'mMC' ?
            <button
              onClick={e => this.checkAnswers(answersCorrect, e.target)}
            >
              {i18n.translate('trainingScreens.confirm')}
            </button> : null}
        </div>
        {error(false)}
      </div>
    );
  }
}

const Inputs = (props) => {
  const {
    answerStyles, activeStyles, answer, change, layout, changeImage,
  } = props;

  const inputs = [];
  return (
    <div className={`form__answers ${layout === 'mCI' ? 'images' : ''}`} >
      {answer.forEach((answerString, index) => {
        const key = index;
        if (layout === 'mCI') {
          inputs.push((
            <ImageAnswer
              change={changeImage}
              key={key}
              id={key}
              text={answerString}
              layout={layout}
            />
          ));
        } else {
          inputs.push(<Answer
            change={change}
            key={key}
            id={key}
            text={answerString}
            layout={layout}
            answerStyle={answerStyles[index]}
            activeStyle={activeStyles[index]}
          />);
        }
      })}
      {inputs}
    </div>
  );
};

const ImageAnswer = (props) => {
  const { text, change, id } = props;
  const image = text.replace(' ', '_').toLowerCase();

  return (
    <div className="input__answer">
      <span
        className="image"
        onClick={(e) => { change(e); }}
        onKeyPress={(e) => { change(e); }}
        role="button"
        tabIndex={0}
      >
        <img id={id} src={image} alt="placeholder" />
      </span>
    </div>
  );
};

const Answer = (props) => {
  const {
    change, id, layout, text, activeStyle,
  } = props;
  return (
    <label
      htmlFor={id}
      className={activeStyle}
    >
      <input
        onChange={e => change(e)}
        id={id}
        type={`${layout === 'mMC' ? 'checkbox' : 'radio'}`}
        name="answer"
        value={text}
      />
      <span
        onClick={(e) => { e.target.previousSibling.checked = true; change(e); }}
        onKeyPress={(e) => { e.target.previousSibling.checked = true; change(e); }}
        role="button"
        tabIndex={0}
      > {props.text}
      </span>
    </label>
  );
};

MultipleChoice.propTypes = {
  answer: PropTypes.arrayOf(PropTypes.string).isRequired,
  answersCorrect: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.bool),
  ]).isRequired,
  contentComplete: PropTypes.func,
  correctAnswerText: PropTypes.string,
  disableHeader: PropTypes.bool,
  error: PropTypes.func,
  incorrectAnswerText: PropTypes.string,
  layout: PropTypes.string,
  question: PropTypes.string,
  disableToast: PropTypes.bool,
};

MultipleChoice.defaultProps = {
  contentComplete: false,
  correctAnswerText: '',
  disableHeader: false,
  error: () => { },
  incorrectAnswerText: '',
  layout: 'mMC',
  question: '',
  disableToast: false,
};

Inputs.propTypes = {
  answer: PropTypes.arrayOf(PropTypes.string).isRequired,
  change: PropTypes.func,
  changeImage: PropTypes.func,
  answerStyles: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeStyles: PropTypes.arrayOf(PropTypes.string).isRequired,
  layout: PropTypes.string,
};

Inputs.defaultProps = {
  change: (() => { }),
  changeImage: (() => { }),
  layout: 'mMC',
};

Answer.propTypes = {
  activeStyle: PropTypes.string.isRequired,
  layout: PropTypes.string,
  text: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  change: PropTypes.func.isRequired,
};

Answer.defaultProps = {
  layout: 'mMC',
};

ImageAnswer.propTypes = {
  text: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  change: PropTypes.func.isRequired,
};
